import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Lifebuoy, ArrowRight } from "@phosphor-icons/react";

export default function SupportCode() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { document.title = "Enter Support Code — Controlly"; }, []);

  const submit = async () => {
    const c = code.replace(/\D/g, "").slice(0, 6);
    if (c.length !== 6) { setError("Enter the 6-digit code your technician gave you."); return; }
    setBusy(true); setError("");
    try {
      const res = await api.get(`/support/resolve-code/${c}`);
      navigate(`/support/join/${res.data.token}`);
    } catch (e) {
      setError(e?.response?.data?.detail || "That code is not valid or has expired.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b1220] text-white flex flex-col items-center justify-center px-4">
      <div className="flex items-center gap-2 mb-8">
        <img src="/controlly-icon.png" alt="Controlly" className="w-9 h-9" />
        <span className="font-heading text-lg font-extrabold tracking-tight">Controlly</span>
      </div>
      <div className="w-full max-w-sm bg-zinc-900 border border-white/10 rounded-2xl p-7 text-center" data-testid="support-code-card">
        <Lifebuoy size={40} weight="fill" className="text-blue-400 mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold tracking-tight">Enter your support code</h1>
        <p className="text-sm text-zinc-400 mt-2">Type the 6-digit code your technician gave you.</p>
        <Input
          data-testid="support-code-input"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          inputMode="numeric"
          placeholder="123456"
          className="bg-zinc-950 border-white/10 mt-5 text-center text-2xl font-mono tracking-[0.4em] h-14"
        />
        {error && <p className="text-sm text-red-400 mt-3" data-testid="support-code-error">{error}</p>}
        <Button data-testid="support-code-submit" onClick={submit} disabled={busy} className="w-full mt-5 h-11 bg-blue-600 hover:bg-blue-500">
          {busy ? "Checking…" : <>Continue <ArrowRight size={17} weight="bold" className="ml-1.5" /></>}
        </Button>
      </div>
      <p className="text-xs text-zinc-600 mt-6">Powered by Controlly · Remote Desktop, Simplified.</p>
    </div>
  );
}
